<div>

  <fieldset class="fieldset">
    <legend class="fieldset-label" *ngIf="config.questionText">{{config.questionText}}</legend>
    <div *ngIf="radioListSelected" class="form-group" [formGroup]='parent'>
      <div class="form-field" *ngFor="let option of radioListSelected, let i=index">
        <div class="col-md-8 clear-all checkbox-container">
          <input tabindex="0" type="radio" class="form-control" aria-invalid="false" 
            [(ngModel)]="radioSelected"
            [name]="parentControlName" [value]="option" [id]="option" (change)="onChangeRadioOption(option)"
            [formControlName]="parentControlName" [attr.disabled]="radioList[i].enable ? null:''" />
          <label tabindex="-1" [for]="option" [id]="option + '-lbl'">{{option}}</label>
        </div>
        <div class="col-md-4 clear-all existing-wrapper" *ngIf="!radioList[i].enable">
          <span class="existing-label">{{existingLabel}}</span>
        </div>
        
      </div>
    </div>
  </fieldset>
</div>